import { ComponentProps, useMemo } from "react"
import { cn } from "@repo/ui/utils"
import type { Components } from "react-markdown"
import ReactMarkdown from "react-markdown"
import rehypeHighlight from "rehype-highlight"
import remarkGfm from "remark-gfm"

import { createCustomComponents } from "./md-components"

type CustomComponents = Partial<ComponentProps<typeof ReactMarkdown>["components"]>

export function MarkdownRender({
  content,
  className,
  isStreaming = false,
  customComponents = {}
}: {
  content: string
  className?: string
  isStreaming: boolean
  customComponents?: CustomComponents
}) {
  const defaultComponents = useMemo(() => createCustomComponents({ isStreaming }), [isStreaming])

  const mergedComponents = useMemo(
    () =>
      ({
        ...defaultComponents,
        ...customComponents
      }) satisfies Components,
    [defaultComponents, customComponents, isStreaming]
  )

  return (
    <ReactMarkdown
      className={cn("prose ![&_a]:text-blue-500", className)}
      components={mergedComponents}
      rehypePlugins={[rehypeHighlight]}
      remarkPlugins={[remarkGfm]}
    >
      {content ?? ""}
    </ReactMarkdown>
  )
}
